var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingCartinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M23.57 46.615a4.714 4.714 0 1 1 0 9.428 4.714 4.714 0 0 1 0-9.428m29.711 0a4.714 4.714 0 1 1 0 9.428 4.714 4.714 0 0 1 0-9.428m-29.711 2a2.714 2.714 0 1 0 0 5.428 2.714 2.714 0 0 0 0-5.428m29.711 0a2.714 2.714 0 1 0 0 5.428 2.714 2.714 0 0 0 0-5.428M14.904 7a1 1 0 0 1 .956.706l2.996 9.198h39.228a2 2 0 0 1 1.897 2.632L53.22 39.82a2 2 0 0 1-1.897 1.367H25.546a2 2 0 0 1-1.911-1.411L14.165 9H4V7Zm43.18 11.904H19.305l6.241 20.284h25.777z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#161719",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export default SvgShoppingCartinline;